(function () {
  'use strict';

  /* ── Close details dropdown when clicking outside ── */
  var details = document.querySelector('.nav-details');
  if (details) {
    document.addEventListener('click', function (e) {
      if (!details.contains(e.target)) {
        details.removeAttribute('open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') details.removeAttribute('open');
    });
  }

  /* ── Mobile menu ── */
  var burger = document.getElementById('BurgerBtn');
  var mobileNav = document.getElementById('MobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  /* ── Qty buttons ── */
  document.querySelectorAll('.qty-ctrl').forEach(function (ctrl) {
    var inp = ctrl.querySelector('.qty-inp');
    var minus = ctrl.querySelector('.qty-minus');
    var plus = ctrl.querySelector('.qty-plus');
    if (!inp) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(inp.value, 10) || 1;
      if (v > 1) inp.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      inp.value = (parseInt(inp.value, 10) || 1) + 1;
    });
  });

  /* ── Gallery thumbs ── */
  var mainImg = document.getElementById('MainImg');
  document.querySelectorAll('.prod-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (mainImg && this.dataset.src) mainImg.src = this.dataset.src;
      document.querySelectorAll('.prod-thumb').forEach(function (x) { x.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ── Collection sort ── */
  var sortEl = document.getElementById('SortBy');
  if (sortEl) {
    var sp = new URLSearchParams(window.location.search);
    if (sp.get('sort_by')) sortEl.value = sp.get('sort_by');
    sortEl.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', this.value);
      window.location.href = u.toString();
    });
  }

  /* ── Ajax Add to Cart ── */
  var pf = document.getElementById('ProductForm');
  if (pf) {
    pf.addEventListener('submit', async function (e) {
      e.preventDefault();
      var btn = this.querySelector('.atc-btn');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'ADDING…'; btn.disabled = true; }
      try {
        var r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(this) });
        if (!r.ok) throw new Error();
        var cart = await (await fetch('/cart.js')).json();
        var cc = document.getElementById('CartCount');
        if (cc) cc.textContent = cart.item_count;
        if (btn) {
          btn.textContent = '✓ ADDED';
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
        }
      } catch (_) {
        if (btn) { btn.textContent = 'TRY AGAIN'; btn.disabled = false; }
      }
    });
  }

  /* ── Sticky ATC bar (mobile) ── */
  var stickyAtc = document.getElementById('StickyAtc');
  var atcBtn = document.querySelector('.atc-btn');
  if (stickyAtc && atcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyAtc.style.display = entries[0].isIntersecting ? 'none' : 'flex';
    }).observe(atcBtn);
  }

}());
